const TOKEN_KEY = 'admin_token'
const API_BASE = process.env.VUE_APP_API_BASE || '/api'

function authHeaders () {
  const token = localStorage.getItem(TOKEN_KEY)
  return token ? { Authorization: `Bearer ${token}` } : {}
}

async function handle (res) {
  if (res.status === 204) return null
  const data = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error((data && data.error) || `Erreur ${res.status}`)
  }
  return data
}

export function isAuthenticated () {
  return !!localStorage.getItem(TOKEN_KEY)
}

export function logout () {
  localStorage.removeItem(TOKEN_KEY)
}

export async function login (username, password) {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  })
  const data = await handle(res)
  localStorage.setItem(TOKEN_KEY, data.token)
  return data
}

export async function me () {
  const res = await fetch(`${API_BASE}/auth/me`, { headers: authHeaders() })
  return handle(res)
}

export async function changePassword (currentPassword, newPassword) {
  const res = await fetch(`${API_BASE}/auth/password`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ currentPassword, newPassword })
  })
  return handle(res)
}

export async function getProjects () {
  const res = await fetch(`${API_BASE}/projects`)
  return handle(res)
}

export async function createProject (project) {
  const res = await fetch(`${API_BASE}/projects`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(project)
  })
  return handle(res)
}

export async function updateProject (id, project) {
  const res = await fetch(`${API_BASE}/projects/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(project)
  })
  return handle(res)
}

export async function deleteProject (id) {
  const res = await fetch(`${API_BASE}/projects/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  })
  return handle(res)
}
